import { atom } from "jotai";

export const OTCPageAtom = atom(1);
export const OTCPageSizeAtom = atom(10);